import React from "react";
import { Box, Divider, Link, Typography } from "@mui/material";

const contacts = [
  {
    name: "Sabrina Silveira",
    profileUrl: "http://lattes.cnpq.br/0899817111748167",
    email: "sabrina@ufv.br",
    orcidLabel: "0000-0002-4723-2349",
    orcidUrl: "https://orcid.org/0000-0002-4723-2349"
  },
  {
    name: "Moruf Adedeji Adeagbo",
    profileUrl: "http://lattes.cnpq.br/8607282294601900",
    email: "moruff.adeagbo@ufv.br",
    orcidLabel: "0000-0002-1664-2070",
    orcidUrl: "https://orcid.org/0000-0002-1664-2070"
  }
];

const Contact = () => {
  return (
    <Box
      component="section"
      className="contact"
      sx={{
        minHeight: "92vh",
        py: 6,
        textAlign: "left",
        px: { xs: 2, md: 6 },
        background: "linear-gradient(180deg, #f7fbff 0%, #ffffff 100%)"
      }}
    >
      <Box
        sx={{
          maxWidth: 1520,
          mx: "auto",
          borderRadius: 4,
          overflow: "hidden",
          border: "1px solid #d7e5f2",
          boxShadow: "0 20px 45px rgba(15, 23, 42, 0.08)",
          backgroundColor: "#fff"
        }}
      >
        <Box
          sx={{
            px: { xs: 3, md: 6 },
            py: { xs: 4, md: 5 },
            color: "#fff",
            background: "linear-gradient(135deg, #123b61 0%, #2c79b6 100%)",
            textAlign: "center"
          }}
        >
          <Typography variant="overline" sx={{ letterSpacing: "0.16em", fontWeight: 700 }}>
            Contact Detail
          </Typography>
          <Typography variant="h3" sx={{ mt: 1, fontWeight: 800, fontSize: { xs: "2rem", md: "2.6rem" } }}>
            Get in Touch
          </Typography>
          <Typography sx={{ mt: 2, maxWidth: 760, mx: "auto", lineHeight: 1.8, opacity: 0.95 }}>
            For questions about PredPPIGReMLIN, collaboration opportunities, or research-related communication,
            please use the institutional and researcher contact details below.
          </Typography>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", lg: "1.05fr 1fr" }
          }}
        >
          <Box sx={{ p: { xs: 3, md: 5 }, backgroundColor: "#f9fbfd" }}>
            <Typography variant="h5" sx={{ color: "#16324a", fontWeight: 800 }}>
              Laboratory and Institutional Address
            </Typography>

            <Box sx={{ mt: 3, color: "#334155", lineHeight: 1.9 }}>
              <Typography>
                <Link
                  href="https://homepages.dcc.ufmg.br/~sabrinas"
                  target="_blank"
                  rel="noreferrer"
                  underline="hover"
                  color="#0f4c81"
                  sx={{ fontWeight: 700 }}
                >
                  LaBio Laboratory of Bioinformatics, Visualization and Systems
                </Link>
              </Typography>
              <Typography>Department of Computer Science</Typography>
              <Typography>Universidade Federal de Vicosa</Typography>
              <Typography>Vicosa - Minas Gerais - Brazil</Typography>
              <Typography>36570-900</Typography>
              <Typography>+55 (31) 3612-6359</Typography>
            </Box>
          </Box>

          <Box sx={{ p: { xs: 3, md: 5 } }}>
            <Typography variant="h5" sx={{ color: "#16324a", fontWeight: 800 }}>
              Research Contacts
            </Typography>

            <Box sx={{ mt: 3, display: "grid", gap: 3 }}>
              {contacts.map((contact, index) => (
                <Box
                  key={contact.email}
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    border: "1px solid #dbe5ef",
                    backgroundColor: "#ffffff",
                    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.05)"
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: 800, color: "#16324a" }}>
                    <Link
                      href={contact.profileUrl}
                      target="_blank"
                      rel="noreferrer"
                      underline="hover"
                      color="#0f4c81"
                    >
                      {contact.name}
                    </Link>
                  </Typography>
                  <Typography sx={{ mt: 1.5, color: "#475569" }}>
                    <Link href={`mailto:${contact.email}`} underline="hover" color="#475569">
                      {contact.email}
                    </Link>
                  </Typography>
                  <Typography sx={{ mt: 1, color: "#475569" }}>
                    ORCID:{" "}
                    {contact.orcidUrl ? (
                      <Link
                        href={contact.orcidUrl}
                        target="_blank"
                        rel="noreferrer"
                        underline="hover"
                        color="#0f4c81"
                      >
                        {contact.orcidLabel}
                      </Link>
                    ) : (
                      contact.orcidLabel
                    )}
                  </Typography>
                  {index < contacts.length - 1 && <Divider sx={{ mt: 3, borderColor: "#e2e8f0" }} />}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Contact;
